import '@albelli/arc-3/lib/promobar.css';
import '@albelli/arc-3/lib/tile.css';
import '@albelli/arc-3/lib/arc.bundle';
import { useEffect } from 'preact/hooks';
import DateFormat from '../date/dateFormat';
import { useTrans } from '../translations/trans';

type CountdownProps = {
    campaignEndDate: string;
    maxDiscount: number;
};

const Countdown = ({ campaignEndDate, maxDiscount }: CountdownProps): Element => {
    const trans = useTrans();
    useEffect(() => {
        new window.ARC3.Countdown('bncl-countdown');
        new window.ARC3.Promobar();
    }, []);
    const title = trans.get('bncl.landingPage.promobar.title').replaceAll('{XX}', maxDiscount);
    const days = trans.get('time.digit.abbreviation.days');
    const hours = trans.get('time.digit.abbreviation.hours');
    const minutes = trans.get('time.digit.abbreviation.minutes');
    const seconds = trans.get('time.digit.abbreviation.seconds');
    return (
        <div className='wrapper'>
            <div className='arc3-promobar --countdown --color-brand-blue'>
                <div className='arc3-promobar__inner-wrapper'>
                    <div
                        className='arc3-tile-wrapper --initial-state voucher-countdown promobar-countdown'
                        data-countdown='bncl-countdown'
                        data-time={campaignEndDate}
                    >
                        <div className='arc3-tile --small'>
                            <div className='arc3-tile__digit' data-digit='days' />
                            <div className='arc3-tile__unit'>{days}</div>
                        </div>

                        <div className='arc3-tile --small'>
                            <div className='arc3-tile__digit' data-digit='hours' />
                            <div className='arc3-tile__unit'>{hours}</div>
                        </div>

                        <div className='arc3-tile --small'>
                            <div className='arc3-tile__digit' data-digit='minutes' />
                            <div className='arc3-tile__unit'>{minutes}</div>
                        </div>

                        <div className='arc3-tile --small'>
                            <div className='arc3-tile__digit' data-digit='seconds' />
                            <div className='arc3-tile__unit'>{seconds}</div>
                        </div>
                    </div>
                    <div className='arc3-promobar__content-wrapper voucher-promobar-content'>
                        <div className='arc3-promobar__content-wrapper__offertext'>
                            <p>
                                <strong>{title}</strong> |
                            </p>
                            <p>
                                &nbsp;
                                <DateFormat
                                    isoDateFormattedString={campaignEndDate}
                                    dateFormatTransKey='promoBar.endDateFormat'
                                />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Countdown;
